<template>
  <div>
    <a-form-model ref="form" :model="form.data" :rules="form.rules">
      <a-form-model-item label="标题">
        <a-input v-model="form.data.title" auto-focus/>
      </a-form-model-item>
      <a-form-model-item label="内容">
        <a-textarea v-model="form.data.content"/>
      </a-form-model-item>
      <a-form-model-item label="背景图(1480*1004)">
        <div class="a-input">
          <multi-uploader
            v-model="form.data.images"
            :options="imagesOptions"/>
        </div>
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" v-if="!storyId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="storyId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">取消</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import { _addStory, _queryStory, _updateStory, } from '@/api/websiteStoryApi';
import MultiUploader from '@/components/MultiUploader.vue';

async function getInstagram() {
  const result = await _queryStory(this.storyId);
  if (result) {
    this.form.data.title = result.title;
    this.form.data.content = result.content;
    this.form.data.image = result.image;
    this.form.data.images = result.images ? result.images.split('|') : [];
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addStory({
        title: this.form.data.title,
        content: this.form.data.content,
        image: this.form.data.image,
        images: this.form.data.images.join('|'),
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateStory(this.storyId, {
        title: this.form.data.title,
        content: this.form.data.content,
        image: this.form.data.image,
        images: this.form.data.images.join('|'),
      });
      if (result) {
        this.$message.success(this.$t('UPDATE_SUCCESS'));
        if (this.onSubmitHandler) {
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'StoryWebsiteEdit',
  components: {
    // SimpleUploader,
    MultiUploader,
  },
  props: {
    storyId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  methods: {
    onAdd,
    onCancel,
    getInstagram,
    onUpdate,
  },
  data() {
    return {
      imagesOptions: {
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 1480, // 默认生成截图框宽度
        autoCropHeight: 1004, // 默认生成截图框高度
        fixedBox: false, // 是否固定截图框大小 不允许改变
        previewsCircle: false, // 预览图是否是圆形
        multi: true,
        serviceType: 'S3',
        title: '修改背景图',
      },
      video: {
        visible: false,
        url: '',
      },
      form: {
        data: {
          title: '',
          image: '',
          content: '',
          images: [],
        },
        rules: {
          title: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  async created() {
    if (this.storyId) {
      await this.getInstagram();
    }
  },
};
</script>
